<template>
  <div id="app" class="app">
    <div class="wrapper">
      <OfflineIndicator />
      <ViewMain />
    </div>
  </div>
</template>

<script>
import OfflineIndicator from '@/Theme/Components/02-atoms/OfflineIndicator/OfflineIndicator.vue';
import ViewMain from '@/Views/Main.vue';

export default {
  name: 'App',
  components: {
    ViewMain,
    OfflineIndicator,
  },
  metaInfo() {
    const metaTitle = this.$i18n.t('meta-title');
    const metaDescription = this.$i18n.t('meta-description');
    return {
      title: metaTitle,
      meta: [
        { name: 'description', content: metaDescription },
        { property: 'og:title', content: metaTitle },
        { property: 'og:description', content: metaDescription },
      ],
    };
  },
};
</script>

<style scoped lang="scss">

</style>
